import { cn } from '@/lib/utils';

type StatusVariant = 'online' | 'offline' | 'error' | 'connecting';

interface StatusIndicatorProps {
  variant: StatusVariant;
  className?: string;
}

const variantClasses: Record<StatusVariant, string> = {
  online: 'status-dot-online',
  offline: 'bg-muted-foreground/40',
  error: 'status-dot-error',
  connecting: 'bg-amber-400 animate-pulse-dot',
};

export function StatusIndicator({ variant, className }: StatusIndicatorProps) {
  return (
    <span className={cn('status-dot', variantClasses[variant], className)} />
  );
}
